"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SitePage = void 0;

var SitePage =
/** @class */
function () {
  function SitePage() {}

  SitePage.prototype.SitePageTemplateDifficultyType = function () {
    return [{
      slug: 'custom',
      name: 'Custom',
      description: null,
      isCustom: true,
      isBeginner: false,
      isIntermediate: false,
      isAdvanced: false,
      isExpert: false
    }, {
      slug: 'beginner',
      name: 'Beginner',
      description: null,
      isCustom: false,
      isBeginner: true,
      isIntermediate: false,
      isAdvanced: false,
      isExpert: false
    }, {
      slug: 'intermediate',
      name: 'Intermediate',
      description: null,
      isCustom: false,
      isBeginner: false,
      isIntermediate: true,
      isAdvanced: false,
      isExpert: false
    }, {
      slug: 'advanced',
      name: 'Advanced',
      description: null,
      isCustom: false,
      isBeginner: false,
      isIntermediate: false,
      isAdvanced: true,
      isExpert: false
    }, {
      slug: 'expert',
      name: 'Expert',
      description: null,
      isCustom: false,
      isBeginner: false,
      isIntermediate: false,
      isAdvanced: false,
      isExpert: true
    }];
  };

  return SitePage;
}();

exports.SitePage = SitePage;